
import { TableLimit } from '@/datamodel/types'
import { isLandscape, toMoneyFormat } from '@/utils'
import { Options } from 'vue-class-component'
import { Mixins, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { DeskMixin } from './mixin'
import MobileBetView from '@/components/desk/betview/m-betview.vue'
import DPredictionSumaryView from '@/components/desk/prediction/d-prediction-sumary-view.vue'
import MobileSwitchTableView from '@/components/desk/switch-table/m-switch-table.vue'
import MGoodRoadPanel from '@/components/desk/good-road/m-good-road-panel.vue'
import GoodRoadBtnSvg from '@/components/header/good-road-btn-svg.vue'
import CustomMoneyView from '@/components/dialogs/custom-money-dialog-view.vue'
import LimitDialogView from '@/components/dialogs/limit-dialog-view.vue'
import MobileSettingDialogView from '@/components/dialogs/m-setting-dialog-view.vue'
import ChangePasswordView from '@/components/dialogs/change-pass-view.vue'
import BetHistory from '@/components/dialogs/history-view.vue'
import MobileCardResultView from '@/components/desk/card-result/m-card-result-view.vue'
import { GAME_TYPE } from '@/utils/constants'
import PopAlertView from '@/components/desk/pop-alert.vue'
import AppSvg from '@/components/app-svg.vue'
import { Table } from 'vue'
import router from '@/router'
import MPrediction from '@/components/desk/prediction/m-prediction-sumary-view.vue'
import RuleView from '@/components/dialogs/rule-view.vue'

@Options({
    components: {
        MobileBetView,
        DPredictionSumaryView,
        MobileSwitchTableView,
        MGoodRoadPanel,
        GoodRoadBtnSvg,
        CustomMoneyView,
        LimitDialogView,
        MobileSettingDialogView,
        ChangePasswordView,
        BetHistory,
        MPrediction,
        'm-card-result-view': MobileCardResultView,
        'app-svg': AppSvg,
        PopAlertView,
        ruleView: RuleView
    }
})
export default class MobileDesk extends Mixins(DeskMixin) {
    currentDesk!: Table
    roadMapKey = new Date().getTime()

    roadmapDisplay = isLandscape() ? 0 : 6

    OnOrientationChange(): void {
        this.isLandscapeMode = isLandscape()
        this.roadMapKey = new Date().getTime()

        setTimeout(() => {
            this.setDeskInfoKey()
            this.noticeIsPaused = false
        }, 1000)

        // alert(document.body.getBoundingClientRect().height)
    }

    get redLimit(): string {
        if (this.currentDesk)
            return `${this.currentDesk.downLimit}-${this.currentDesk.upLimit}`
        return '0-0'
    }

    @Watch('isLandscapeMode', { immediate: true })
    OnRoadmapDisplayModeChange(isTrue: boolean): void {
        this.roadmapDisplay = isTrue ? 0 : 6
    }
}
